module.exports = "/_next/static/images/document-duotone-106441dfd02ea1b023b8a4d0dc1ff375.svg";